import React, { useEffect, useRef } from "react";
import Layout from "../../../components/towerHeadAdmin/Layout";
import Helmet from "react-helmet";
import Table from "../../../components/ui/Table";
import usePaginate from "../../../hooks/api/usePaginate";
import apiRequest from "../../../utils/towerHeadAdmin/apiRequest";
import useModal from "../../../hooks/ui/useModal";
import Pagination from "../../../components/ui/Pagination";
import { FaEdit, FaPlus, FaTrashAlt } from "react-icons/fa";
import Modal from "../../../components/ui/utils/Modal";
import Button from "../../../components/ui/utils/Button";
import useFormInput from "../../../hooks/form/useFormInput";
import { useSelector } from "react-redux";

import InputField from "../../../components/ui/form/InputField";
import CreateStaffAdmin from "../../../components/towerHeadAdmin/admin/staffAdmin/CreateStaffAdmin";
import EditStaffAdmin from "../../../components/towerHeadAdmin/admin/staffAdmin/EditStaffAdmin";
import DeleteStaffAdmin from "../../../components/towerHeadAdmin/admin/staffAdmin/DeleteStaffAdmin";

const StaffAdmin = () => {
    const {
        currentPage,
        data,
        error,
        fetchData,
        limit,
        loading,
        setPage,
        setSorting,
        sort,
        totalItems,
        totalPages,
        setFilters,
    } = usePaginate({
        apiMethod: apiRequest.getAdmin,
        dataKey: "admins",
    });

    const { isOpen, openModal, closeModal, actionType } = useModal();
    const handleSort = (field) => {
        const order =
            sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
        setSorting({ sortField: field, sortOrder: order });
    };



    const searchInitialValues = { code: "" };
    const { values, handleChange, setValues } = useFormInput(searchInitialValues);
    const debounceRef = useRef(null);
    useEffect(() => {
        if (values.code !== undefined) {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
            }
            debounceRef.current = setTimeout(() => {
                const filters = {};
                filters.type = "admin";
                if (values.code) {
                    filters.code = { $regex: values.code, $options: "i" };
                }
                setFilters(filters);
            }, 500);
            return () => clearTimeout(debounceRef.current);
        }
    }, [values.code]);

    const BRAND_NAME = useSelector(
        (state) => state.globalState?.siteSetting?.site_settings?.site_name
    );
    return (
        <Layout>
            <Helmet>
                <title>Vendor - {BRAND_NAME ?? ''}</title>
            </Helmet>

            <div className="p-4 bg-white rounded">
                <div className="flex items-center gap-1 py-2">
                    {/* <Button
                        onClick={() => openModal({ type: "add" })}
                        variant="primary"
                        isLoading={false}
                    >
                        <div className="flex items-center justify-center gap-3">
                            <FaPlus />
                            <p>Add  Admin</p>
                        </div>
                    </Button> */}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-[1fr_100px] gap-2 my-2">
                    <InputField
                        name="code"
                        placeholder="e.g. Summer25"
                        value={values.code}
                        onChange={handleChange}
                    />
                    <button
                        className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800"
                        onClick={() => setValues(searchInitialValues)}
                    >
                        Clear
                    </button>
                </div>

                <Table
                    headers={[
                        { label: "Name", key: "name", sorting: true },
                        { label: "City", key: "city", sorting: true },
                        { label: "Mobile", key: "mobile", sorting: false },
                        { label: "Vendor Type", key: "vendorType", sorting: true },
                        { label: "Super Vendor", key: "isSuperVendor", sorting: true },
                        { label: "Created At", key: "createdAt", sorting: true },
                        {
                            label: "Action",
                            key: "action",
                            sorting: false,
                        },
                    ]}
                    loading={loading}
                    handleSort={handleSort}
                    sort={sort}
                    error={error}
                    cols={7}
                    renderRow={
                        <tbody className="bg-white divide-y divide-gray-200">
                            {data?.map((vendor) => {
                                
                                return (
                                    <tr key={vendor._id} className="transition-colors hover:bg-gray-50">
                                        <td className="px-3 py-3">
                                            <span className="font-semibold text-gray-800">{vendor.name}</span>
                                        </td>
                                        <td className="px-3 py-3">
                                            <span className="text-xs text-gray-500">{vendor?.cityId?.name}</span>
                                        </td>
                                        <td className="px-3 py-3">
                                            <span className="text-xs text-gray-500">{vendor.mobile}</span>
                                        </td>
                                        <td className="px-3 py-3">
                                            <span className="text-xs text-gray-500">{vendor.vendorType || "-"}</span>
                                        </td>
                                        <td className="px-3 py-3">
                                            <span
                                                className={`inline-block px-2 py-1 text-xs font-semibold rounded ${vendor.isSuperVendor
                                                    ? "bg-green-100 text-green-700"
                                                    : "bg-gray-200 text-gray-500"
                                                    }`}
                                            >
                                                {vendor.isSuperVendor ? "Yes" : "No"}
                                            </span>
                                        </td>
                                        <td className="px-3 py-3">
                                            <span className="text-xs text-gray-400">
                                                {new Date(vendor.createdAt).toLocaleDateString()}
                                            </span>
                                        </td>
                                        <td className="px-3 py-3">
                                            <div className="flex justify-center gap-3">
                                                <button
                                                    onClick={() => openModal({ type: "edit", data: { state: vendor } })}
                                                    className="text-primary"
                                                    title="Edit"
                                                >
                                                    <FaEdit size={18} />
                                                </button>
                                                <button
                                                    onClick={() => openModal({ type: "delete", data: { state: vendor } })}
                                                    className="text-red-500"
                                                    title="Delete"
                                                >
                                                    <FaTrashAlt size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    }
                />
                {totalPages > 1 && (
                    <Pagination
                        pagination={{
                            currentPage,
                            totalPages,
                            totalItems: totalItems,
                            perPage: limit,
                        }}
                        handlePageChange={setPage}
                        loading={loading}
                    />
                )}
            </div>
            <Modal isOpen={isOpen} onClose={closeModal} size="large">
                {actionType?.type === "add" && (
                    <CreateStaffAdmin closeModal={closeModal} callback={fetchData} />
                )}
                {actionType?.type === "edit" && (
                    <EditStaffAdmin
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}
                {actionType?.type === "delete" && (
                    <DeleteStaffAdmin
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}
            </Modal>
        </Layout>
    );
};

export default StaffAdmin;
